function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1667 17.3083L18.7418 13.3333L0.83334 15.1877L1.25848 19.1667L19.1667 17.3083Z",
  fill: "#FFE900"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4936 10.2955V14.4444H14.9852V11.6566C14.9852 11.6566 13.7949 14.4444 9.41591 14.4444C6.48247 14.4444 4.84569 12.9518 4.12296 12.0078C3.55182 11.2492 3.12615 10.3849 2.86879 9.46138C2.53976 8.25835 2.51779 6.98789 2.80503 5.77346C3.16329 4.12067 4.06461 2.64693 5.35586 1.60264C5.97186 1.10526 6.66073 0.712514 7.39652 0.439187C8.56668 0.00242473 9.827 -0.111082 11.0527 0.10991C12.3741 0.333423 13.6059 0.942799 14.6026 1.86606L14.9427 2.17339L13.1571 4.01734L12.9658 3.84172C12.2293 3.17199 11.3088 2.75608 10.3326 2.65186C9.35644 2.54765 8.37306 2.76032 7.51941 3.26028C6.66574 3.76024 5.98425 4.52261 5.5698 5.44127C5.15535 6.35992 5.02855 7.38917 5.20706 8.38578C5.3302 9.09886 5.61358 9.77222 6.03444 10.3517C6.45531 10.9312 7.00191 11.4007 7.63035 11.7225C8.39557 12.1615 9.64977 12.1834 10.5213 12.0517C13.4122 11.5907 13.9649 8.73697 13.9649 8.73697H9.9261V6.14669H17.4936V10.2955Z",
  fill: "black"
});

function SvgIcGoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoto);
export default __webpack_public_path__ + "static/media/ic_goto.8001bb30e3fb589dd94af1010116ce34.svg";
export { ForwardRef as ReactComponent };